import type { WhatIsPassportFeature } from './types'

export const TITLE = 'Watch PBS, Anytime and Anywhere'

export const getWithoutColumnHeader = (stationName: string) =>
  `Without ${stationName} Passport`

export const getWithColumnHeader = (stationName: string) =>
  `With ${stationName} Passport`

export const getMoreInfoText = (displayUrl: string) =>
  `For more information visit: ${displayUrl || 'passport.pbs.org'}`

export const getFeatures = (stationName: string): WhatIsPassportFeature[] => [
  {
    label: 'Watch new specials and currently airing PBS shows',
    withoutPassport: true,
    withPassport: true,
  },
  {
    label: `Enjoy Live TV from ${stationName}`,
    withoutPassport: true,
    withPassport: true,
  },
  {
    label: 'Catch up on the latest news and public affairs',
    withoutPassport: true,
    withPassport: true,
  },
  {
    label: 'Get extended access to past seasons of PBS shows',
    withoutPassport: false,
    withPassport: true,
  },
  {
    label: 'Stream early releases of new series',
    withoutPassport: false,
    withPassport: true,
  },
  {
    label: 'Binge watch your favorite PBS shows',
    withoutPassport: false,
    withPassport: true,
  },
]

export const getTTSText = (stationName: string) =>
  `${TITLE}. ` +
  `${getWithoutColumnHeader(stationName)}: ` +
  'Watch new specials and currently airing PBS shows. ' +
  `Enjoy Live TV from ${stationName}. ` +
  'Catch up on the latest news and public affairs. ' +
  `${getWithColumnHeader(stationName)}: ` +
  'Enjoy all of the above, plus: ' +
  'Get extended access to past seasons of PBS shows. ' +
  'Stream early releases of new series. ' +
  'Binge watch your favorite PBS shows.'
